var map = {
	"./Claim1.pdf": "f356",
	"./Claim2.pdf": "b472",
	"./Claim3.pdf": "8143",
	"./Claim4.pdf": "d87a",
	"./Claim5.pdf": "c27d",
	"./Claim6.pdf": "8544",
	"./Claim7.pdf": "3579"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d745";